import { render } from "./GestaoDeMudanca.vue?vue&type=template&id=8c0b5114&scoped=true"
import script from "./GestaoDeMudanca.vue?vue&type=script&lang=js"
export * from "./GestaoDeMudanca.vue?vue&type=script&lang=js"

import "./GestaoDeMudanca.vue?vue&type=style&index=0&id=8c0b5114&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c0b5114"]])

export default __exports__